import { useSelector } from 'react-redux';
import Button from '../webapp/core/Button';

const EventProposalCTA = ({ onButtonClick, onBookNowClick, hidden }) => {
  const event = useSelector((state) => state.proposalData.data);
  return (
    <div className={['event-proposal__cta', hidden ? 'event-proposal__cta--hidden' : null].join(' ')}>
      <Button color={event.micrositeAccentColor} onClick={onButtonClick} disabled={hidden}>
        See More
      </Button>
      {event.proposalConfig.button.enabled &&
      !!event.proposalConfig.button.text &&
      !!event.proposalConfig.button.url ? (
        <button className="text-link text-link--muted" onClick={onBookNowClick} disabled={hidden}>
          Or Book Now
        </button>
      ) : null}
    </div>
  );
};

export default EventProposalCTA;
